export enum AAB_PERMISSIONS {
  MANAGE_EMPLOYEES = 'MANAGE_EMPLOYEES',
  BURN_POINTS = 'BURN_POINTS',
  VIEW_ANALYTICS = 'VIEW_ANALYTICS',
  AAB_COMPANY_PORTAL_READ = 'AAB_COMPANY_PORTAL_READ',
  AAB_COMPANY_ORDERS_READ = 'AAB_COMPANY_ORDERS_READ',
  AAB_EMPLOYEE_SELF_READ = 'AAB_EMPLOYEE_SELF_READ',
  AAB_COMPANY_FILE_READ = 'AAB_COMPANY_FILE_READ',
  AAB_EMPLOYEE_INVITATION_READ = 'AAB_EMPLOYEE_INVITATION_READ',
  AAB_COMPANY_SETTINGS_UPSERT = 'AAB_COMPANY_SETTINGS_UPSERT',
  AAB_COMPANY_TRANSACTION_READ = 'AAB_COMPANY_TRANSACTION_READ',
  AAB_COMPANY_READ = 'AAB_COMPANY_READ',
  AAB_POINTS_READ = 'AAB_POINTS_READ',
  AAB_COMPANY_UPDATE = 'AAB_COMPANY_UPDATE',
  AAB_OPERATION_COMPANY_READ = 'AAB_OPERATION_COMPANY_READ',
  AAB_EMPLOYEE_READ = 'AAB_EMPLOYEE_READ',
  AAB_COMPANY_BALANCE_READ = 'AAB_COMPANY_BALANCE_READ',
  AAB_COMPANY_FILE_DELETE = 'AAB_COMPANY_FILE_DELETE',
  AAB_COMPANY_GROUP_CREATE = 'AAB_COMPANY_GROUP_CREATE',
  AAB_COMPANY_DOMAINS_UPSERT = 'AAB_COMPANY_DOMAINS_UPSERT',
  AAB_COMPANY_FILE_UPSERT = 'AAB_COMPANY_FILE_UPSERT',
  AAB_RESERVATION_READ = 'AAB_RESERVATION_READ',
  AAB_EMPLOYEE_STAYS_READ = 'AAB_EMPLOYEE_STAYS_READ',
  AAB_COMPANY_TRAVEL_POLICY_UPSERT = 'AAB_COMPANY_TRAVEL_POLICY_UPSERT',
  AAB_EMPLOYEE_UPSERT = 'AAB_EMPLOYEE_UPSERT',
  AAB_EMPLOYEE_UNLINK = 'AAB_EMPLOYEE_UNLINK',
  AAB_COMPANY_REPORTS_READ = 'AAB_COMPANY_REPORTS_READ',
  AAB_EMPLOYEE_PURGE = 'AAB_EMPLOYEE_PURGE',
  AAB_COMPANY_TRAVEL_POLICY_READ = 'AAB_COMPANY_TRAVEL_POLICY_READ',
  AAB_EMPLOYEE_TNC_UPDATE = 'AAB_EMPLOYEE_TNC_UPDATE',
  AAB_EMPLOYEE_INVITATION_UPSERT = 'AAB_EMPLOYEE_INVITATION_UPSERT',
  AAB_ACCOUNT_BALANCE_READ = 'AAB_ACCOUNT_BALANCE_READ',
  AAB_COMPANY_GROUP_UPDATE = 'AAB_COMPANY_GROUP_UPDATE',
  AAB_COMPANY_INVITATION_DELETE = 'AAB_COMPANY_INVITATION_DELETE',
  AAB_COMPANY_SETTINGS_READ = 'AAB_COMPANY_SETTINGS_READ',
  AAB_COMPANY_GROUP_DELETE = 'AAB_COMPANY_GROUP_DELETE',
  AAB_EMPLOYEE_INVITATION_DELETE = 'AAB_EMPLOYEE_INVITATION_DELETE'
}
